import React from 'react';
import {connect} from 'react-redux';
import * as a from './../actions';
import {canAddIngredient, canRemoveIngredient, formatMoney} from "../functions";
import {currencyCode, localeCode} from "../selectors";

function Ingredient({
    ingredient, addIngredient, removeIngredient,
    canAddIngredient, canRemoveIngredient, formatMoney
})  {
    let price = ((ingredient.count || 0) * (ingredient.price || 0));
    return (
        <div className="ingredient">
            <span className="ingredient__label">{ingredient.label}</span>
            <span className="ingredient__buttons">
                {price > 0 ? <span className="ingredient__price">+{formatMoney(price)}</span> : ''}
                <button
                    onClick={() => removeIngredient(ingredient)}
                    className={`btn btn--cart-edit ${canRemoveIngredient(ingredient) ? '' : ' invisible '}`}
                >-</button>
                <span className="ingredient__count">{ingredient.count || 0}</span>
                <button
                    onClick={() => addIngredient(ingredient)}
                    className={`btn btn--cart-edit ${canAddIngredient(ingredient) ? '' : ' invisible '}`}
                >+</button>
            </span>
        </div>
    );
}

export default connect(
    (state) => ({
        canAddIngredient: ingredient => canAddIngredient(state, ingredient),
        canRemoveIngredient: ingredient => canRemoveIngredient(state, ingredient),
        formatMoney: price => formatMoney(currencyCode(state), localeCode(state), price)
    }),
    (dispatch) => ({
        addIngredient: ingredient => dispatch(a.addIngredient(ingredient)),
        removeIngredient: ingredient => dispatch(a.removeIngredient(ingredient)),
    })
)(Ingredient);
